import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import NavigationBar from './Navbar.tsx';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider.tsx';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const location = useLocation();
  const showNavbar = !['/login', '/*'].includes(location.pathname);

  const { user } = useAuth();

  if (!showNavbar || !user || (location.pathname.includes('/camera'))) {
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#0A0F15', color: 'white' }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0
          }}
        >
          {children}
        </Box>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#0A0F15', color: 'white' }}>
      {!isMobile && (
        <img
          src="/top.webp"
          width="100%"
          height="150px"
          alt="Background"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
      )}
      <NavigationBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          mt: isMobile ? 0 : '70px',
          mb: isMobile ? 7 : 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;